module.exports = __webpack_public_path__ + "img/51626531_L.2aa35aca.png";